module.exports = __webpack_public_path__ + "img/alarm-clock.2e70913d.png";